<pr-page [load]="loading">
  @if (groups) {
    <pr-panel>
      <pr-panel-header class="panel-header-simulation" [title]="title">
        @if (pdf) {
          <ea-simulation-download
            [simulation]="simulation"
            icon="file_open"
            label="Télécharger (PDF)"
            class="mrxs"
            (loadingChange)="setLoading($event)"
            (downloaded)="onDownload.emit()"
          ></ea-simulation-download>
        }
        <pr-button
          display="neutral"
          size="lg"
          icon="edit"
          label="Modifier les paramètres"
          (onClick)="triggerForm()"
        >
        </pr-button>
      </pr-panel-header>
      <pr-panel-body clazz="pal">
        <div
          class="parameters-body grid-col-md-1 grid"
          [ngClass]="'grid-col-' + groups.length || 0"
        >
          @for (group of groups; track group) {
            <ng-container
              [ngTemplateOutlet]="
                group.hasOwnProperty('showMap') &&
                group.showMap(simulation) === true
                  ? groupMapTemplate
                  : (group.hasOwnProperty('showContent') &&
                        group.showContent(simulation) === true) ||
                      (!group.parameters && group.hasOwnProperty('content'))
                    ? panelTemplate
                    : groupTemplate
              "
              [ngTemplateOutletContext]="{ $implicit: group }"
            >
            </ng-container>
          }
        </div>
      </pr-panel-body>
    </pr-panel>
  }

  <ng-template #groupTemplate let-group>
    <div class="parameters-group">
      <div class="parameters-group-header">{{ resolveValue(group.label) }}</div>
      @for (parameter of group.parameters; track parameter) {
        <div>
          @if (showOnlyIf(parameter)) {
            <div class="parameter">
              @if (parameter.icon) {
                <pr-label
                  [name]="parameter.icon"
                  [width]="16"
                  [height]="14"
                  [tooltip]="parameter.tooltip"
                  labelClass="fs-14"
                  >{{ parameter.label }}</pr-label
                >
              }
              <span class="parameter-value">{{ value(parameter) }}</span>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>

  <ng-template #groupMapTemplate let-group>
    <div class="parameters-group group-map">
      <pr-map [address]="simulation.parameters.address"></pr-map>
    </div>
  </ng-template>

  <ng-template #panelTemplate let-group>
    @if (group.content) {
      <pr-color-panel [display]="group.display" clazz="pam">
        <pr-panel-header [title]="resolveValue(group.label)"></pr-panel-header>
        <pr-panel-body>
          <span
            [innerHTML]="sanitizer.bypassSecurityTrustHtml(group.content)"
            class="text-dark"
          ></span>
        </pr-panel-body>
      </pr-color-panel>
    }
  </ng-template>
</pr-page>
